import React from 'react';

const TermsAndConditions = () => {
  return (
    <div>
        <div className="relative w-full h-56 lg:h-60 bg-black opacity-80">
            <img
                src={require('../images/carousel/purple.jpg')}
                className="absolute top-0 left-0 w-full h-full object-cover"
                alt="Background"
            />
            <div className="absolute inset-0 flex items-center justify-center">
                <h1 className="text-white text-xl lg:text-2xl font-bold">Terms And Conditions</h1>
            </div>
        </div>
    <div className="max-w-3xl mx-auto p-6 bg-gray-100 rounded-md shadow-lg mb-10 mt-5">
      <p className="mb-4 text-sm">
        Welcome to Rupleart.com ("the Website"). These Terms and Conditions outline the rights and 
        responsibilities of all visitors, buyers, and artists ("users") who use our platform to sell or 
        purchase artwork, including paintings, drawings, and all manner of artworks. By using the 
        Website, you agree to the following terms.
      </p>

      <h2 className="text-md font-semibold mt-6 mb-2">1. General Overview</h2>
      <p className="mb-2 text-sm">
        <strong>1.1. Platform Purpose:</strong> Rupleart.com provides a marketplace for artists to sell original artwork 
        and for buyers to purchase these works. The Website acts as an intermediary platform and 
        does not take responsibility for the quality or condition of the items sold.
      </p>
      <p className="mb-2 text-sm">
        <strong>1.2. Acceptance of Terms:</strong> By accessing or using the Website, you acknowledge that you have 
        read, understood, and agree to be bound by these Terms and Conditions.
      </p>

      <h2 className="text-md font-semibold mt-6 mb-2">2. Eligibility</h2>
      <p className="mb-2 text-sm">
        <strong>2.1. Artists:</strong> To sell on the Website, you must be at least 18 years old or have reached the legal 
        age of majority in your jurisdiction.
      </p>
      <p className="mb-2 text-sm">
        <strong>2.2. Buyers:</strong> To purchase artwork, you must provide accurate payment information and agree 
        to follow the purchase processes outlined on the Website.
      </p>

      <h2 className="text-md font-semibold mt-6 mb-2">3. Copyright Ownership and Intellectual Property</h2>
      <p className="mb-2 text-sm">
        <strong>3.1. Artist’s Copyright:</strong> The artist retains full copyright ownership of their artwork, even after it 
        has been sold. The buyer receives the physical artwork or a licensed digital copy, but not the 
        copyright.
      </p>
      <p className="mb-2 text-sm">
        <strong>3.2. License of Usage:</strong> By submitting your artwork to the Website, you grant Rupleart.com a 
        non-exclusive, royalty-free license to use, reproduce, and display your artwork for marketing 
        and promotional purposes. This license does not transfer ownership but allows the platform to 
        feature your work on the Website, social media, and other promotional channels.
      </p>
      <p className="mb-2 text-sm">
        <strong>3.3. Buyer’s Usage:</strong> Buyers of artwork receive the right to display the artwork for personal, noncommercial purposes. The buyer may not reproduce, distribute, or create derivative works 
        from the purchased artwork without explicit written permission from the artist.
      </p>

      <h2 className="text-md font-semibold mt-6 mb-2">4. Payments</h2>
      <p className="mb-2 text-sm">
        <strong>4.1. Currency:</strong> All payments on Rupleart will be processed in Kenyan Shillings (KES). Buyers must 
        ensure that they are aware of any currency conversion fees if making purchases from outside 
        Kenya.
      </p>
      <p className="mb-2 text-sm">
        <strong>4.2. Payment Methods:</strong> We accept secure online payments via credit cards, debit cards, mobile 
        money platforms such as M-Pesa, and other secure payment gateways.
      </p>
      <p className="mb-2 text-sm">
        <strong>4.3. Pricing:</strong> The prices displayed for artwork are set by the artists and are inclusive of any 
        applicable Kenyan taxes. Shipping fees, if applicable, will be added to the total price at 
        checkout.
      </p>

      <h2 className="text-md font-semibold mt-6 mb-2">5. Artist Responsibilities</h2>
      <p className="mb-2 text-sm">
        <strong>5.1. Authenticity:</strong> Artists are responsible for ensuring that the work they upload and sell on the 
        Website is original and does not infringe upon the intellectual property rights of others.
      </p>
      <p className="mb-2 text-sm">
        <strong>5.2. Pricing:</strong> Artists set their own prices for their artwork in Kenyan Shillings and ensuring all 
        descriptions and images are accurate. The Website charges a commission fee of 12% for each 
        sale, which will be deducted from the final price.
      </p>
      <p className="mb-2 text-sm">
        <strong>5.3. Representation:</strong> Artists agree that all descriptions, photos, and representations of their 
        artwork are accurate and truthful. Misrepresentation of work is strictly prohibited and may 
        result in the removal of the artist’s account.
      </p>

      <h2 className="text-md font-semibold mt-6 mb-2">6. Buyer Responsibilities</h2>
      <p className="mb-2 text-sm">
        <strong>6.1. Payment:</strong> Buyers must provide valid payment information and complete their purchases using one of the 
        supported payment methods in Kenyan Shillings. Rupleart does not bear responsibility for any 
        conversion or transaction fees imposed by financial institutions.
      </p>
      <p className="mb-2 text-sm">
        <strong>6.2. Order Completion:</strong> Buyers must provide accurate shipping details and are responsible for any 
        customs duties or taxes imposed by their local authorities (for international buyers).
      </p>
      <p className="mb-2 text-sm">
        <strong>6.3. Returns and Refunds:</strong> All returns, exchanges, or refunds are subject to the individual 
        policies set by the artist unless otherwise stated on the Website. Buyers should contact the 
        website’s contact directly for any issues regarding their purchase.
      </p>

      <h2 className="text-md font-semibold mt-6 mb-2">7. Prohibited Uses</h2>
      <p className="mb-2 text-sm">
        <strong>7.1. Unauthorized Reproduction:</strong> Buyers may not reproduce, distribute, or resell artwork 
        purchased on the Website without the express written consent of the artist/website 
        management. Users must not post, list, or transmit any inappropriate, offensive, or unlawful 
        material on Rupleart. This includes counterfeit or stolen artwork, which will result in the 
        termination of the user’s account.
      </p>
      <p className="mb-2 text-sm">
        <strong>7.2. Misuse of the Website:</strong> Any fraudulent, misleading, or inappropriate behavior on the 
        platform will result in account suspension or termination. Users are prohibited from attempting 
        to bypass the Rupleart payment systems or engage in fraudulent transactions. Violations may 
        result in legal action and account suspension.
      </p>

      <h2 className="text-md font-semibold mt-6 mb-2">8. Termination</h2>
      <p className="mb-2 text-sm">
        <strong>8.1. Termination by the Artist or Buyer:</strong> Artists and buyers may terminate their accounts at any 
        time by notifying Rupleart.com.
      </p>
      <p className="mb-2 text-sm">
        <strong>8.2. Termination by the Website:</strong> Rupleart reserves the right to suspend or terminate accounts 
        at its sole discretion for violations of these Terms and Conditions or for any fraudulent, illegal, or 
        any reason deemed appropriate by the Website administrators.
      </p>

      <h2 className="text-md font-semibold mt-6 mb-2">9. Dispute Resolution</h2>
      <p className="mb-2 text-sm">
        <strong>9.1. In the Event of Dispute:</strong> Any disputes regarding artwork quality, shipping, or refunds must 
        first be addressed directly between the buyer and the artist, whose contact information will be 
        shared between the two parties. The Website will attempt to mediate any disputes between 
        artists and buyers. However, the Website is not responsible for resolving disputes or providing 
        legal advice.
      </p>
      <p className="mb-2 text-sm">
        <strong>9.2. Governing Law:</strong> These Terms and Conditions are governed by the laws of Kenya, and any 
        legal disputes will be resolved in courts located within this jurisdiction.
      </p>

      <h2 className="text-md font-semibold mt-6 mb-2">10. Limitation of Liability</h2>
      <p className="mb-2 text-sm">
        Rupleart is a platform that facilitates transactions between buyers and artists. We are not 
        responsible for the artwork listed or sold on the Website, including issues related to quality, 
        authenticity, or legal claims. Rupleart shall not be held liable for any damages arising from the 
        use or inability to use the Website or for any third-party claims.
      </p>

      <h2 className="text-md font-semibold mt-6 mb-2">11. Amendments</h2>
      <p className="mb-2 text-sm">
        The Website reserves the right to update or modify these Terms and Conditions at any time 
        without prior notice. Continued use of the Website constitutes acceptance of any changes.
      </p>

      <h2 className="text-md font-semibold mt-6 mb-2">12. Contact Information</h2>
      <p>If you have any questions or concerns about these Terms and Conditions, please contact us at:</p>
      <p>Email: <a href="mailto:Rupleart@gmail.com" className="text-blue-600 hover:underline">Rupleart@gmail.com</a></p>
      <p>Phone: 0759324250</p>
    </div>
    </div>
  );
};

export default TermsAndConditions;
